export function btn(ctx) {
    return {
        styles: {
            main: { ...ctx.btnStyle, radius: 999, text_font: 32 },
        },
    };
}
